module.exports = __webpack_public_path__ + "img/tc.9f060600.svg";